import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChaperoneContext } from './Hooks';
import { containerRemoveChild, is } from './Utils';

export const Chaperone = ({
	autoTrigger,
	id,
	waitSearchIndex,
	onDone,
	onSkip,
	children,
}) => {
	const [chaperone, setChaperone] = useState({
		index: autoTrigger ? 0 : -1,
		matched: false,
		skip: false,
		done: false,
		currentId: id,
		previousIndex: -1,
	});
	useEffect(() => {
		let delay;
		if (!chaperone.matched) {
			delay = setTimeout(() => {
				const doneProperly = chaperone.done || chaperone.skip;
				doneProperly && containerRemoveChild();
				if (
					!doneProperly &&
					chaperone.index > -1 &&
					is.dev
				) {
					throw new Error(
						`ChaperoneStep id="${chaperone.currentId}" index={${
							chaperone.index
						}} is not found, or you probably have missed to assign isDone or isDoneOnClick to "true" on your last index "${
							chaperone.index - 1
						}" ChaperoneStep`
					);
				}
			}, waitSearchIndex);
			const ev = {
				indexEnded: chaperone.index,
				previousId: chaperone.currentId,
				trigger: (id, step = 0) =>
					setChaperone((prev) => ({
						...prev,
						index: step,
						currentId: id,
						skip: false,
						done: false,
					})),
			};
			chaperone.done && onDone && onDone(ev);
			chaperone.skip && onSkip && onSkip(ev);
		}
		return () => clearTimeout(delay);
	}, [chaperone, waitSearchIndex, onDone, onSkip]);

	useEffect(() => () => containerRemoveChild(), []);
	return (
		<ChaperoneContext.Provider value={{ chaperone, setChaperone }}>
			{children}
		</ChaperoneContext.Provider>
	);
};

Chaperone.propTypes = {
	autoTrigger: PropTypes.bool,
	id: PropTypes.string,
	waitSearchIndex: PropTypes.number,
	onDone: PropTypes.func,
	onSkip: PropTypes.func,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]).isRequired,
};

Chaperone.defaultProps = {
	autoTrigger: false,
	waitSearchIndex: 50,
};
